export const CURRENCY = { symbol: "$", code: "USD" };

export function fmtCurrency(n, opts = {}) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: CURRENCY.code,
    maximumFractionDigits: opts.max ?? (Math.abs(n) < 100 ? 2 : 0),
    minimumFractionDigits: 0,
  }).format(n);
}

export function fmtNum(n, digits = 0) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: digits }).format(n);
}

export function fmtPct(n, digits = 0) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return `${Number(n).toFixed(digits)}%`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function timeAgo(iso) {
  if (!iso) return "—";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return `${Math.floor(s)}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export const VENDOR_LABEL = { microsoft: "Microsoft", anthropic: "Anthropic", openai: "OpenAI", other: "Other" };
